/* unplugin-vue-components disabled */import script from "./selectPost.vue?vue&type=script&setup=true&name=SelectPost&lang=js"
export * from "./selectPost.vue?vue&type=script&setup=true&name=SelectPost&lang=js"

import "./selectPost.vue?vue&type=style&index=0&id=6c0fc0a7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0fc0a7"]])

export default __exports__